import { useMemo } from "react"
import type { ExtractedField } from "../types"
import type { ClientSummary } from "@/services/invoiceService"

interface UseInvoiceTypeProps {
    client?: ClientSummary | { id: string; name: string; vat_code?: string } | null
    vendorFields: ExtractedField[]
}

interface UseInvoiceTypeReturn {
    isIncome: boolean
}

export const useInvoiceType = ({ client, vendorFields }: UseInvoiceTypeProps): UseInvoiceTypeReturn => {
    const isIncome = useMemo(() => {
        if (!client) return false

        const vendorName = vendorFields.find((f) => f.field_name === "vendor_name")?.field_value
        const vendorTaxId = vendorFields.find((f) => f.field_name === "vendor_tax_id")?.field_value

        // Check VAT match (strong signal)
        if (vendorTaxId && client.vat_code) {
            const cleanVendor = vendorTaxId.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
            const cleanClient = client.vat_code.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

            if (cleanVendor.includes(cleanClient) || cleanClient.includes(cleanVendor)) {
                return true
            }
        }

        // Check Name match (fuzzy)
        if (
            vendorName &&
            client.name &&
            vendorName.toLowerCase().includes(client.name.toLowerCase())
        ) {
            return true
        }

        return false
    }, [client, vendorFields])

    return { isIncome }
}
